import { useState, useEffect, useContext } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import moment from "moment-timezone";
import Loader from "../layout/Loader";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Alert from "../Alert";
import { alertContext } from "../contexts/AlertProvider";
import DriverPerformance from "./DriverPerformance";
import PermissionGate from "../layout/PermissionGate";
import DriverPayout from "./details/DriverPayout";
import DriverMaxOrderScanLimit from "./details/DriverMaxOrderScanLimit";

const DriverDetails = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({});
  const [licenceSize, setLicenceSize] = useState(0);
  const [govtIdSize, setGovtIdSize] = useState(0);
  const [vehicleDocumentSize, setVehicleDocumentSize] = useState(0);
  const [_, setAlertConfig] = useContext(alertContext);
  const { id } = useParams();
  const token = localStorage.getItem("token");

  const fetchDriverDetails = () => {
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + `driver-details?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(async (res) => {
        if (res.data.code === 1) {
          setData(res.data.data[0]);
          setLicenceSize(
            await getFileSize(
              process.env.REACT_APP_API_PUBLIC_URL +
              res?.data?.data?.at(0)?.licencePhoto,
            ),
          );
          setGovtIdSize(
            await getFileSize(
              process.env.REACT_APP_API_PUBLIC_URL +
              res?.data?.data?.at(0)?.govtIdPhoto,
            ),
          );
          setVehicleDocumentSize(
            await getFileSize(
              process.env.REACT_APP_API_PUBLIC_URL +
              res?.data?.data?.at(0)?.vehicleDocument,
            ),
          );
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch(console.error);
  };
  const getFileSize = async (url) => {
    const size = axios
      .head(url)
      .then((res) => {
        let fileSize = res.headers.get("Content-Length");
        if (fileSize) {
          fileSize = (parseInt(fileSize, 10) / 1024).toFixed(2);
        } else {
          fileSize = 0;
        }
        return fileSize;
      })
      .catch(() => {
        return 0;
      });
    return size;
  };

  useEffect(() => {
    fetchDriverDetails();
  }, []);

  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Driver Details
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
                {/*begin::Actions*/}
                <div className="d-flex align-items-center">
                  {/*begin::Edit Button*/}
                  <PermissionGate
                    required={`edit_driver_details`}
                    fallback={<></>}
                    show={false}
                  >
                    <Link
                      to={`/drivers/edit-driver/${id}`}
                      className="ms-4 btn btn-color-success bg-body me-3"
                    >
                      <i className="bi-duotone bi-pen"></i>
                      Edit
                    </Link>
                  </PermissionGate>
                  {/*end::Edit Button*/}
                </div>
                {/*end::Actions*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}

            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              <div className="content flex-row-fluid" id="kt_content">
                <div className="row g-5 g-lg-10">
                  {/*begin::Card*/}
                  <PermissionGate required={`view_driver_details`}>
                    <div className="card">
                      {/*begin::Card header*/}
                      <div className="card-header border-0 pt-6">
                        {/*begin::Card title*/}
                        <div className="card-title"></div>
                        {/*begin::Card title*/}
                      </div>
                      {/*end::Card header*/}

                      {/*begin::Card body*/}
                      <div className="card-body py-4">
                        <div className="row">
                          <div className="col">
                            <div className="d-flex flex-wrap flex-sm-nowrap">
                              {/*begin: Pic*/}
                              <div className="me-7 mb-4">
                                <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                                  <img
                                    src={`${process.env.REACT_APP_API_PUBLIC_URL}${data?.profilePhoto}`}
                                    alt={data?.name}
                                  />
                                  <div
                                    className={
                                      data?.status === true
                                        ? "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-body h-20px w-20px"
                                        : "position-absolute translate-middle bottom-0 start-100 mb-6 bg-danger rounded-circle border border-4 border-body h-20px w-20px"
                                    }
                                  ></div>
                                </div>
                              </div>
                              {/*end::Pic*/}

                              {/*begin::Info*/}
                              <div className="flex-grow-1">
                                {/*begin::Title*/}
                                <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                  {/*begin::User*/}
                                  <div className="d-flex flex-column">
                                    {/*begin::Name*/}
                                    <div className="align-items-center mb-1">
                                      <span className="text-gray-900 text-hover-primary fs-2 fw-bold me-1">
                                        {data?.name}
                                      </span>
                                      <p className="text-gray-400">
                                        {data?.email}
                                      </p>
                                    </div>
                                    {/*end::Name*/}

                                    {/*begin::Info*/}
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        WORK PHONE
                                      </span>
                                      <p className="text-white-300">
                                        {data?.workPhone}
                                      </p>
                                    </div>
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        PERSONAL PHONE
                                      </span>
                                      <p className="text-white-300">
                                        {data?.personalPhone}
                                      </p>
                                    </div>
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        BIRTHDAY
                                      </span>
                                      <p className="text-white-300">
                                        {moment(data?.dob, "DD-MM-YYYY")
                                          .tz(process.env.REACT_APP_TIMEZONE)
                                          .format("Do MMM, YYYY")}
                                      </p>
                                    </div>
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        GENDER
                                      </span>
                                      <p className="text-white-300">
                                        {data?.gender}
                                      </p>
                                    </div>
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        DRIVER TYPE
                                      </span>
                                      <p className="text-white-300">
                                        {data?.type}
                                      </p>
                                    </div>
                                    {/*end::Info*/}
                                  </div>
                                  {/*end::User*/}
                                </div>
                                {/*end::Title*/}
                              </div>
                              {/*end::Info*/}
                              {/*begin::Info*/}
                              <div className="flex-grow-1">
                                {/*begin::Title*/}
                                <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                  {/*begin::User*/}
                                  <div className="d-flex flex-column">
                                    {/*begin::Name*/}
                                    <div className="align-items-center mb-2">
                                      <span className="text-gray-900 text-hover-primary fs-2 fw-bold me-1">
                                        Vehicles
                                      </span>
                                    </div>
                                    {/*end::Name*/}

                                    {/*begin::Info*/}
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        MAKE
                                      </span>
                                      <p className="text-white-300">
                                        {data?.vehicleMake}
                                      </p>
                                    </div>
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        MODEL
                                      </span>
                                      <p className="text-white-300">
                                        {data?.vehicleModel}
                                      </p>
                                    </div>
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        YEAR
                                      </span>
                                      <p className="text-white-300">
                                        {data?.vehicleYear}
                                      </p>
                                    </div>
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        PLATE
                                      </span>
                                      <p className="text-white-300">
                                        {data?.vehiclePlate}
                                      </p>
                                    </div>
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        REGISTRATION
                                      </span>
                                      <p className="text-white-300">
                                        {data?.vehicleRegistration}
                                      </p>
                                    </div>
                                    {/*end::Info*/}
                                  </div>
                                  {/*end::User*/}
                                </div>
                                {/*end::Title*/}
                              </div>
                              {/*end::Info*/}

                              {/*begin::Info*/}
                              <div className="flex-grow-1">
                                {/*begin::Title*/}
                                <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                  {/*begin::User*/}
                                  <div className="d-flex flex-column">
                                    {/*begin::Name*/}
                                    <div className="align-items-center mb-2">
                                      <span className="text-gray-900 text-hover-primary fs-2 fw-bold me-1">
                                        Government ID
                                      </span>
                                    </div>
                                    {/*end::Name*/}

                                    {/*begin::Info*/}
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        DOCUMENT TYPE
                                      </span>
                                      <p className="text-white-300">
                                        {data?.govtIdType}
                                      </p>
                                    </div>
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        COUNTRY
                                      </span>
                                      <p className="text-white-300">
                                        {data?.govtIdCountry}
                                      </p>
                                    </div>
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        NUMBER
                                      </span>
                                      <p className="text-white-300">
                                        {data?.govtIdNo}
                                      </p>
                                    </div>
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        EXPIRES AT
                                      </span>
                                      <p className="text-white-300">
                                        {moment(
                                          data?.govtIdExpiaryDate,
                                          "DD-MM-YYYY",
                                        )
                                          .tz(process.env.REACT_APP_TIMEZONE)
                                          .format("Do MMM, YYYY")}
                                      </p>
                                    </div>
                                    {/*end::Info*/}
                                  </div>
                                  {/*end::User*/}
                                </div>
                                {/*end::Title*/}
                              </div>
                              <div className="flex-grow-1">
                                {/*begin::Title*/}
                                <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                  {/*begin::User*/}
                                  <div className="d-flex flex-column">
                                    {/*begin::Name*/}
                                    <div className="align-items-center mb-2">
                                      <span className="text-gray-900 text-hover-primary fs-2 fw-bold me-1">
                                        Driver licence
                                      </span>
                                    </div>
                                    {/*end::Name*/}

                                    {/*begin::Info*/}
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        NUMBER
                                      </span>
                                      <p className="text-white-300">
                                        {data?.licenceNo}
                                      </p>
                                    </div>
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        COUNTRY
                                      </span>
                                      <p className="text-white-300">
                                        {data?.licenceCountry}
                                      </p>
                                    </div>
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        ISSUED AT
                                      </span>
                                      <p className="text-white-300">
                                        {moment(
                                          data?.licenceIssueDate,
                                          "DD-MM-YYYY",
                                        )
                                          .tz(process.env.REACT_APP_TIMEZONE)
                                          .format("Do MMM, YYYY")}
                                      </p>
                                    </div>
                                    <div className="fs-25 pe-2">
                                      <span className="d-flex align-items-center text-gray-400 me-5">
                                        EXPIRES AT
                                      </span>
                                      <p className="text-white-300">
                                        {moment(
                                          data?.licenceExpiaryDate,
                                          "DD-MM-YYYY",
                                        )
                                          .tz(process.env.REACT_APP_TIMEZONE)
                                          .format("Do MMM, YYYY")}
                                      </p>
                                    </div>
                                    {/*end::Info*/}
                                  </div>
                                  {/*end::User*/}
                                </div>
                                {/*end::Title*/}
                              </div>
                              {/*begin::Title*/}
                              <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                {/*begin::User*/}
                                <div className="d-flex flex-column">
                                  {/*begin::Name*/}
                                  <div className="align-items-center mb-2">
                                    <span className="text-gray-900 text-hover-primary fs-2 fw-bold me-1">
                                      Driver Preferences
                                    </span>
                                  </div>
                                  {/*end::Name*/}

                                  {/*begin::Info*/}
                                  <div className="fs-25 pe-2 mb-2">
                                    <span className="d-flex align-items-center text-gray-400 me-5">
                                      CUSTOM SHARING
                                    </span>
                                    <p className="text-white-300">
                                      {data?.sharing > 0
                                        ? `${data?.sharing}%`
                                        : "Not Submitted"}
                                    </p>
                                  </div>
                                  {/*end::Info*/}
                                </div>
                                {/*end::User*/}
                              </div>
                              {/*end::Title*/}

                              {/*end::Info*/}
                            </div>
                          </div>
                        </div>
                        <div className="overflow-auto pb-5">
                          <div className="d-flex align-items-center border border-dashed border-gray-300 rounded min-w-700px p-5">
                            {/*begin::Licence*/}
                            <div className="d-flex flex-aligns-center pe-10 pe-lg-20">
                              <img
                                alt=""
                                className="w-40px me-3"
                                src={
                                  process.env.REACT_APP_PUBLIC_URL +
                                  "icons/certificate.png"
                                }
                              />
                              <div className="ms-1 fw-semibold">
                                <a
                                  href={`${process.env.REACT_APP_API_PUBLIC_URL}${data?.licencePhoto}`}
                                  className="fs-6 text-hover-primary fw-bold"
                                  target="_blank"
                                  download
                                >
                                  Driving Licence
                                </a>
                                <div className="text-gray-400">
                                  {licenceSize}KB
                                </div>
                              </div>
                            </div>
                            {/*end::Licence*/}

                            {/*begin::Government Id*/}
                            <div className="d-flex flex-aligns-center pe-10 pe-lg-20">
                              <img
                                alt=""
                                className="w-40px me-3"
                                src={
                                  process.env.REACT_APP_PUBLIC_URL +
                                  "icons/contract.png"
                                }
                              />
                              <div className="ms-1 fw-semibold">
                                <a
                                  href={`${process.env.REACT_APP_API_PUBLIC_URL}${data?.govtIdPhoto}`}
                                  className="fs-6 text-hover-primary fw-bold"
                                  target="_blank"
                                  download
                                >
                                  Government Id
                                </a>
                                <div className="text-gray-400">
                                  {govtIdSize}KB
                                </div>
                              </div>
                            </div>
                            {/*end::Government Id*/}

                            {/*begin::Vehicle Document*/}
                            <div className="d-flex flex-aligns-center pe-10 pe-lg-20">
                              <img
                                alt=""
                                className="w-40px me-3"
                                src={
                                  process.env.REACT_APP_PUBLIC_URL +
                                  "icons/paper.png"
                                }
                              />
                              <div className="ms-1 fw-semibold">
                                <a
                                  href={`${process.env.REACT_APP_API_PUBLIC_URL}${data?.vehicleDocument}`}
                                  className="fs-6 text-hover-primary fw-bold"
                                  target="_blank"
                                  download
                                >
                                  Vehicle Document{" "}
                                </a>
                                <div className="text-gray-400">
                                  {vehicleDocumentSize}KB
                                </div>
                              </div>
                            </div>
                            {/*end::Vehicle Document*/}
                          </div>
                        </div>
                      </div>
                      {/*end::Card body*/}
                    </div>
                  </PermissionGate>
                  {/*end::Card*/}
                </div>
                <PermissionGate
                  required={`view_driver_pricing_model_list`}
                  fallback={<></>}
                  show={false}
                >
                  <div className="row g-5 g-lg-10 mt-4">
                    <div className="col p-0 mb-xl-10">
                      <h1 className="d-flex text-dark fw-bold m-0 fs-3 mb-5">
                        Settings
                      </h1>
                      <DriverPayout
                        id={id}
                        setAlertConfig={setAlertConfig}
                        fetchDriverDetails={fetchDriverDetails}
                        data={data}
                      />
                    </div>
                  </div>
                </PermissionGate>
                <PermissionGate
                  required={`change_driver_max_order_scan_limit`}
                  show={false}
                >
                  <div className="row g-5 g-lg-10 mt-4">
                    <div className="col p-0 mb-xl-10">
                      <h1 className="d-flex text-dark fw-bold m-0 fs-3 mb-5">
                        Max Order Scan Limit
                      </h1>
                      <DriverMaxOrderScanLimit
                        id={id}
                        setAlertConfig={setAlertConfig}
                        fetchDriverDetails={fetchDriverDetails}
                        data={data}
                      />
                    </div>
                  </div>
                </PermissionGate>
                <DriverPerformance id={id} />
              </div>
            </div>
          </div>
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default DriverDetails;
